import React, { useState, useEffect, useCallback } from "react";
import { MessageCircle, RefreshCw, Send, X } from "lucide-react";
import { toast } from "sonner";

const fmt = (iso) => new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });

// Envio do Signature Book por WhatsApp — mensagem gerada pela IA, revisada antes de abrir o WhatsApp.
export const SBWhatsAppBox = ({ obra, api, url }) => {
  const [msg, setMsg] = useState(null); // { mensagem, telefone, envio_numero, fonte }
  const [texto, setTexto] = useState("");
  const [busy, setBusy] = useState(false);
  const [hist, setHist] = useState([]);
  const loadHist = useCallback(() => api("get", `/obras/${obra.id}/sb-whatsapp/historico`).then(setHist).catch(() => {}), [api, obra.id]);
  useEffect(() => { loadHist(); }, [loadHist]);

  const gerar = async () => {
    setBusy(true);
    try {
      const r = await api("post", `/obras/${obra.id}/sb-whatsapp/gerar`, { sb_url: url });
      setMsg(r);
      setTexto(r.mensagem);
    } catch (e) { toast.error(e?.response?.data?.detail || "Não foi possível gerar a mensagem"); }
    finally { setBusy(false); }
  };

  const abrir = () => {
    const tel = msg.telefone;
    window.open(`https://wa.me/${tel || ""}?text=${encodeURIComponent(texto)}`, "_blank", "noopener");
    api("post", `/obras/${obra.id}/sb-whatsapp/registrar`, { mensagem: texto, gerada: msg.mensagem, frase: msg.frase || "" })
      .then(() => { toast.success("Mensagem registrada no histórico"); loadHist(); })
      .catch(() => toast.error("WhatsApp aberto, mas o histórico não foi salvo"));
    setMsg(null);
  };

  return (
    <div style={{ marginTop: 16 }} data-testid="sb-whatsapp-box">
      {!msg && (
        <button className="btn btn-ghost" onClick={gerar} disabled={busy} data-testid="sb-whatsapp-btn">
          <MessageCircle size={12} /> {busy ? "Escrevendo mensagem..." : "Enviar SB por WhatsApp"}
        </button>
      )}
      {msg && (
        <div style={{ border: "1px solid var(--gold-3)", background: "var(--bg-3)", padding: 14 }} data-testid="sb-whatsapp-preview">
          <div style={{ fontSize: 10, letterSpacing: 1.5, textTransform: "uppercase", color: "var(--gold)", marginBottom: 8 }}>
            {msg.envio_numero === 1 ? "Primeiro envio" : `Reenvio nº ${msg.envio_numero}`} · revise antes de enviar
          </div>
          <textarea className="input" value={texto} onChange={e => setTexto(e.target.value)} rows={16}
            style={{ width: "100%", fontSize: 13, lineHeight: 1.6, resize: "vertical" }} data-testid="sb-whatsapp-texto" />
          {!msg.telefone && (
            <div style={{ fontSize: 11, color: "#c47a7a", marginTop: 6 }} data-testid="sb-whatsapp-sem-telefone">
              Obra sem telefone do cliente — o WhatsApp vai pedir para escolher o contato.
            </div>
          )}
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 10 }}>
            <button className="btn btn-primary" onClick={abrir} disabled={!texto.trim()} data-testid="sb-whatsapp-abrir"><Send size={12} /> Abrir WhatsApp</button>
            <button className="btn btn-ghost" onClick={gerar} disabled={busy} data-testid="sb-whatsapp-regerar"><RefreshCw size={12} /> {busy ? "Gerando..." : "Gerar outra"}</button>
            <button className="btn btn-ghost" onClick={() => setMsg(null)} data-testid="sb-whatsapp-cancelar"><X size={12} /> Cancelar</button>
          </div>
        </div>
      )}
      {hist.length > 0 && (
        <details style={{ marginTop: 10 }} data-testid="sb-whatsapp-historico">
          <summary style={{ cursor: "pointer", fontSize: 11, color: "var(--ink-3)" }}>Mensagens já enviadas ({hist.length})</summary>
          {hist.map(h => (
            <div key={h.id} style={{ borderTop: "1px solid var(--line)", padding: "8px 0", fontSize: 12, whiteSpace: "pre-wrap", color: "var(--ink-2)" }}>
              <div style={{ fontSize: 10, color: "var(--ink-3)", marginBottom: 4 }}>{fmt(h.at)} · {h.by}{h.editada ? " · editada" : ""}{h.etapa ? ` · ${h.etapa}` : ""}</div>
              {h.mensagem}
            </div>
          ))}
        </details>
      )}
    </div>
  );
};
